(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jbg-rewards-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jbg-rewards-showcase')) {
  customElements.define('jbg-rewards-showcase', class extends HTMLElement {
    connectedCallback() {
      this.cancelFlips();
      this.closeAudio();
      this.effectsObserver?.disconnect();
      this.flips = new Map();
      this.controller?.abort();
      this.controller = new AbortController();
      this.soundButton = this.querySelector('.jbg-rewards__sound');
      if (this.soundButton) this.soundButton.hidden = true;
      this.setSoundStatus('disabled');
      if (this.dataset.revealEnabled !== 'true') return;
      this.setupAmbientMotion();
      this.soundUrl = '';
      try {
        const url = new URL(this.dataset.soundUrl || '', document.baseURI);
        if (this.dataset.soundUrl?.trim() && (url.protocol === 'https:' || (url.protocol === 'http:' && url.origin === window.location.origin))) this.soundUrl = url.href;
      } catch {}
      this.soundAllowed = this.dataset.soundEnabled === 'true' && !!this.soundUrl && !!(window.AudioContext || window.webkitAudioContext);
      const volume = Number(this.dataset.soundVolume ?? 50);
      this.soundVolume = Number.isFinite(volume) ? Math.max(0, Math.min(100, volume)) / 100 : .5;
      this.soundEnabled = true;
      try { this.soundEnabled = localStorage.getItem(this.soundStorageKey()) !== 'off'; } catch {}
      this.updateSoundControl();
      this.setSoundStatus(this.dataset.soundEnabled !== 'true' ? 'disabled' : !this.dataset.soundUrl?.trim() ? 'empty' : this.soundAllowed ? this.soundEnabled ? 'loading' : 'muted' : 'error');
      if (this.soundAllowed && this.soundEnabled) {
        if ('IntersectionObserver' in window) {
          this.soundObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.soundObserver?.disconnect();
            this.prepareSound();
          }, { rootMargin: '300px' });
          this.soundObserver.observe(this);
        } else this.prepareSound();
      }
      this.remember = this.dataset.rememberReveals === 'true' && !window.Shopify?.designMode;
      this.querySelectorAll('.jbg-rewards__card').forEach((card) => {
        this.finishFlip(card, this.wasRevealed(card));
      });
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element) || event.target.closest('a')) return;
        if (event.target.closest('.jbg-rewards__motion')) {
          this.motionPaused = !this.motionPaused;
          try { localStorage.setItem(this.motionStorageKey(), this.motionPaused ? 'paused' : 'on'); } catch {}
          this.updateAmbientMotion();
          return;
        }
        if (event.target.closest('.jbg-rewards__sparkles')) {
          this.sparklesPaused = !this.sparklesPaused;
          try { localStorage.setItem(this.sparklesStorageKey(), this.sparklesPaused ? 'paused' : 'on'); } catch {}
          this.updateAmbientMotion();
          return;
        }
        if (event.target.closest('.jbg-rewards__sound')) {
          this.soundEnabled = !this.soundEnabled;
          if (!this.soundEnabled) this.stopFlipSound();
          else this.prepareSound();
          this.updateSoundControl();
          this.setSoundStatus(!this.soundEnabled ? 'muted' : this.soundLoadFailed ? 'error' : this.soundBuffer ? 'ready' : 'loading');
          try { localStorage.setItem(this.soundStorageKey(), this.soundEnabled ? 'on' : 'off'); } catch {}
          return;
        }
        const card = event.target.closest('.jbg-rewards__card');
        if (!card || !this.contains(card)) return;
        this.setRevealed(card, card.classList.contains('is-concealed'), true);
      }, { signal: this.controller.signal });
      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.jbg-rewards__card');
        if (card && this.contains(card)) this.setRevealed(card, true);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.cancelFlips();
      this.closeAudio();
      this.effectsObserver?.disconnect();
      this.dataset.effectsVisible = 'false';
      this.controller?.abort();
    }

    motionStorageKey() {
      return `jbg-reward-motion:v1:${this.dataset.themeId}`;
    }

    sparklesStorageKey() {
      return `jbg-reward-extra-sparkles:v1:${this.dataset.themeId}`;
    }

    hasShineEffects() {
      return this.dataset.ambientEnabled === 'true' || (this.dataset.rareShineEnabled === 'true' && !!this.querySelector('.jbg-rewards__reveal[data-rare-reward="true"]'));
    }

    hasExtraSparkles() {
      return ['glitter', 'twinkle', 'fairy_dust', 'constellation', 'shooting_stars'].includes(this.dataset.sparkleStyle);
    }

    setupAmbientMotion() {
      this.motionButton = this.querySelector('.jbg-rewards__motion');
      this.sparkleButton = this.querySelector('.jbg-rewards__sparkles');
      this.motionPaused = false;
      this.sparklesPaused = false;
      try { this.motionPaused = localStorage.getItem(this.motionStorageKey()) === 'paused'; } catch {}
      try { this.sparklesPaused = localStorage.getItem(this.sparklesStorageKey()) === 'paused'; } catch {}
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.effectsInView = false;
      this.updateAmbientMotion();
      if (!this.hasShineEffects() && !this.hasExtraSparkles()) return;
      this.reducedMotion.addEventListener('change', () => this.updateAmbientMotion(), { signal: this.controller.signal });
      document.addEventListener('visibilitychange', () => this.updateAmbientMotion(), { signal: this.controller.signal });
      if ('IntersectionObserver' in window) {
        this.effectsObserver = new IntersectionObserver((entries) => {
          this.effectsInView = entries.some((entry) => entry.isIntersecting);
          this.updateAmbientMotion();
        });
        this.effectsObserver.observe(this.querySelector('.jbg-rewards__grid'));
      } else {
        this.effectsInView = true;
        this.updateAmbientMotion();
      }
    }

    updateAmbientMotion() {
      const paused = this.motionPaused || this.reducedMotion.matches;
      const sparklesPaused = this.sparklesPaused || this.reducedMotion.matches;
      this.dataset.motionPaused = String(paused);
      this.dataset.sparklesPaused = String(sparklesPaused);
      this.dataset.effectsVisible = String(this.effectsInView && !document.hidden);
      if (this.motionButton) {
        this.motionButton.hidden = this.dataset.showShineButton === 'false' || !this.hasShineEffects() || this.reducedMotion.matches;
        this.motionButton.setAttribute('aria-pressed', String(!paused));
        this.motionButton.querySelector('.jbg-rewards__motion-on').hidden = paused;
        this.motionButton.querySelector('.jbg-rewards__motion-off').hidden = !paused;
      }
      if (this.sparkleButton) {
        this.sparkleButton.hidden = this.dataset.showSparkleButton === 'false' || !this.hasExtraSparkles() || this.reducedMotion.matches;
        this.sparkleButton.setAttribute('aria-pressed', String(!sparklesPaused));
        this.sparkleButton.querySelector('.jbg-rewards__sparkles-on').hidden = sparklesPaused;
        this.sparkleButton.querySelector('.jbg-rewards__sparkles-off').hidden = !sparklesPaused;
      }
    }

    cancelFlips() {
      this.flips?.forEach((flip, card) => this.cancelFlip(card));
    }

    cancelFlip(card) {
      const flip = this.flips?.get(card);
      if (!flip) return;
      this.flips.delete(card);
      if (this.soundCard === card) this.stopFlipSound();
      flip.animation?.cancel();
      flip.controller.abort();
      this.finishFlip(card, flip.revealed, flip.remember);
    }

    soundStorageKey() {
      return `jbg-reward-sound:v1:${this.dataset.themeId}`;
    }

    setSoundStatus(state) {
      const status = this.querySelector('.jbg-rewards__sound-status');
      if (status) status.textContent = status.dataset[state] || '';
    }

    updateSoundControl() {
      if (!this.soundButton) return;
      this.soundButton.hidden = !this.soundAllowed || this.soundLoadFailed;
      this.soundButton.setAttribute('aria-pressed', String(this.soundEnabled));
      this.soundButton.querySelector('.jbg-rewards__sound-on').hidden = !this.soundEnabled;
      this.soundButton.querySelector('.jbg-rewards__sound-off').hidden = this.soundEnabled;
    }

    prepareSound() {
      if (!this.soundAllowed || !this.soundEnabled || !this.isConnected || this.soundLoad) return;
      const load = { controller: new AbortController() };
      this.soundLoad = load;
      this.setSoundStatus('loading');
      try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        const context = new AudioContextClass({ latencyHint: 'interactive' });
        this.audioContext = context;
        load.promise = fetch(this.soundUrl, { credentials: 'omit', signal: load.controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Audio unavailable');
            return response.arrayBuffer();
          })
          .then((data) => {
            if (this.soundLoad !== load || !this.isConnected) return null;
            return context.decodeAudioData(data);
          })
          .then((buffer) => {
            if (this.soundLoad !== load || !this.isConnected || !buffer) return;
            this.soundBuffer = buffer;
            this.setSoundStatus(this.soundEnabled ? 'ready' : 'muted');
          })
          .catch(() => {
            if (this.soundLoad !== load || load.controller.signal.aborted) return;
            this.soundLoadFailed = true;
            this.updateSoundControl();
            this.setSoundStatus('error');
          });
      } catch {
        this.soundLoadFailed = true;
        this.updateSoundControl();
        this.setSoundStatus('error');
      }
    }

    stopFlipSound() {
      this.soundSequence = (this.soundSequence || 0) + 1;
      this.soundCard = null;
      const sound = this.activeSound;
      this.activeSound = null;
      if (!sound) return;
      try { sound.source.stop(); } catch {}
      sound.source.disconnect();
      sound.gain.disconnect();
    }

    closeAudio() {
      this.stopFlipSound();
      this.soundObserver?.disconnect();
      this.soundObserver = null;
      this.soundLoad?.controller.abort();
      this.soundLoad = null;
      this.soundLoadFailed = false;
      const context = this.audioContext;
      this.audioContext = null;
      this.soundBuffer = null;
      if (context && context.state !== 'closed') {
        try { context.close().catch(() => {}); } catch {}
      }
    }

    playFlipSound(card) {
      this.stopFlipSound();
      if (!this.soundAllowed || !this.soundEnabled || !this.isConnected || this.soundVolume === 0) return;
      if (!this.soundBuffer) {
        this.prepareSound();
        return;
      }
      const sequence = this.soundSequence;
      const requestedAt = performance.now();
      const context = this.audioContext;
      this.soundCard = card;
      const play = () => {
        if (sequence !== this.soundSequence || !this.soundEnabled || !this.isConnected || !card.isConnected || context.state !== 'running' || performance.now() - requestedAt > 150) return;
        try {
          const source = context.createBufferSource();
          const gain = context.createGain();
          this.activeSound = { source, gain };
          source.buffer = this.soundBuffer;
          gain.gain.setValueAtTime(this.soundVolume, context.currentTime);
          source.connect(gain);
          gain.connect(context.destination);
          source.onended = () => {
            source.disconnect();
            gain.disconnect();
            if (this.activeSound?.source === source) this.activeSound = null;
          };
          source.start();
        } catch { this.stopFlipSound(); }
      };
      try {
        if (context.state === 'running') play();
        else context.resume().then(play).catch(() => {});
      } catch {}
    }

    storageKey(card) {
      return `jbg-reward-reveal:v1:${this.dataset.themeId}:${this.id}:${card.dataset.rewardId}`;
    }

    rewardVersion(card) {
      return JSON.stringify([this.dataset.revealCampaign, card.dataset.rewardVersion]);
    }

    wasRevealed(card) {
      if (!this.remember) return false;
      try {
        return localStorage.getItem(this.storageKey(card)) === this.rewardVersion(card);
      } catch {
        return false;
      }
    }

    showFace(card, revealed) {
      card.classList.toggle('is-concealed', !revealed);
      card.querySelector('.jbg-rewards__reveal').hidden = revealed;
      card.querySelector('.jbg-rewards__return').hidden = !revealed;
    }

    async setRevealed(card, revealed, userInitiated = false) {
      const content = card.querySelector('.jbg-rewards__card-content');
      const button = card.querySelector('.jbg-rewards__reveal');
      const returnButton = card.querySelector('.jbg-rewards__return');
      if (!content || !button || !returnButton) return;
      if (this.flips.has(card)) {
        if (userInitiated) return;
        this.cancelFlip(card);
      }
      if (userInitiated && revealed !== !card.classList.contains('is-concealed')) this.playFlipSound(card);
      if (!userInitiated || revealed === !card.classList.contains('is-concealed') || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof card.animate !== 'function') {
        this.finishFlip(card, revealed, userInitiated, userInitiated);
        return;
      }
      const flip = { revealed, remember: userInitiated, controller: new AbortController(), animation: null, canFocus: card.contains(document.activeElement) };
      this.flips.set(card, flip);
      const trackInteraction = (event) => {
        if (!card.contains(event.target) && (event.type === 'pointerdown' || event.target !== document.body)) flip.canFocus = false;
      };
      document.addEventListener('focusin', trackInteraction, { signal: flip.controller.signal });
      document.addEventListener('pointerdown', trackInteraction, { signal: flip.controller.signal });
      content.inert = true;
      card.classList.add('is-flipping');
      card.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      returnButton.setAttribute('aria-disabled', 'true');
      const direction = revealed ? -1 : 1;
      try {
        flip.animation = card.animate([
          { transform: 'perspective(1100px) rotateY(0deg)' },
          { transform: `perspective(1100px) rotateY(${direction * 90}deg)` }
        ], { duration: 260, easing: 'cubic-bezier(.55, .055, .675, .19)', fill: 'forwards' });
        await flip.animation.finished;
        if (this.flips.get(card) !== flip) return;
        this.showFace(card, revealed);
        flip.animation.cancel();
        flip.animation = card.animate([
          { transform: `perspective(1100px) rotateY(${-direction * 90}deg)` },
          { transform: 'perspective(1100px) rotateY(0deg)' }
        ], { duration: 340, easing: 'cubic-bezier(.215, .61, .355, 1)', fill: 'forwards' });
        await flip.animation.finished;
      } catch {
      } finally {
        if (this.flips.get(card) === flip) {
          this.flips.delete(card);
          flip.animation?.cancel();
          flip.controller.abort();
          this.finishFlip(card, revealed, true, flip.canFocus);
        }
      }
    }

    finishFlip(card, revealed, remember = false, moveFocus = false) {
      const content = card.querySelector('.jbg-rewards__card-content');
      const button = card.querySelector('.jbg-rewards__reveal');
      const returnButton = card.querySelector('.jbg-rewards__return');
      if (!content || !button || !returnButton) return;
      this.showFace(card, revealed);
      content.inert = !revealed;
      card.classList.remove('is-flipping');
      card.removeAttribute('aria-busy');
      [button, returnButton].forEach((control) => {
        control.setAttribute('aria-expanded', String(revealed));
        control.removeAttribute('aria-disabled');
      });
      if (moveFocus && this.isConnected) (revealed ? returnButton : button).focus({ preventScroll: true });
      if (remember && this.remember) {
        try {
          if (revealed) localStorage.setItem(this.storageKey(card), this.rewardVersion(card));
          else localStorage.removeItem(this.storageKey(card));
        } catch {}
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
